"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullShapeViewModel = exports.nullPartitionSmallMultiplesModel = void 0;
var config_1 = require("../config");
var defaultFont = {
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontFamily: '',
    fontWeight: 'normal',
    textColor: 'black',
    textOpacity: 1,
};
var nullPartitionSmallMultiplesModel = function (partitionLayout) { return ({
    index: 0,
    innerIndex: 0,
    smAccessorValue: '',
    panelTitle: '',
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    innerRowCount: 0,
    innerColumnCount: 0,
    innerRowIndex: 0,
    innerColumnIndex: 0,
    marginLeftPx: 0,
    marginTopPx: 0,
    panelInnerWidth: 0,
    panelInnerHeight: 0,
    partitionLayout: partitionLayout,
}); };
exports.nullPartitionSmallMultiplesModel = nullPartitionSmallMultiplesModel;
var nullShapeViewModel = function (specifiedConfig, diskCenter) { return (__assign(__assign({}, exports.nullPartitionSmallMultiplesModel((specifiedConfig || config_1.config).partitionLayout)), { config: specifiedConfig || config_1.config, layers: [], quadViewModel: [], rowSets: [], linkLabelViewModels: {
        linkLabels: [],
        labelFontSpec: defaultFont,
        valueFontSpec: defaultFont,
        strokeColor: '',
    }, outsideLinksViewModel: [], diskCenter: diskCenter || { x: 0, y: 0 }, pickQuads: function () { return []; }, outerRadius: 0 })); };
exports.nullShapeViewModel = nullShapeViewModel;
//# sourceMappingURL=viewmodel_types.js.map